import React, {useEffect, useState} from 'react'
import { Card, CardBody, FormFeedback, Input } from 'reactstrap';
import {useDispatch, useSelector} from "react-redux";
import {getCompanyCountryData, getCompanyPincodeData, getCompanyStateData} from "../../../store/Settings/actions";
import {country_list, state_list} from "../../../common/data/settings";
import {SETTINGS_INITIALIZE} from "../../../store/Settings/actiontype";



const TenantsInformationForm = ({ companyDetailsFormik, proceedToNext, activeItem, isCopyShipperSameAsBilling, onShipperCountryChange }) => {
    const { settings_companyCity_data, settings_companyState_data, settings_companyCountry_data, settings_companyPincode_data } = useSelector((state) => state?.settings);
    const dispatch = useDispatch();


    useEffect(() => {
        console.log(activeItem, "activeItem TenantsInformationForm")

        if (settings_companyState_data && settings_companyState_data?.content?.length > 0 && activeItem === 'customerdetails') {
            companyDetailsFormik.setFieldValue("shipperStateId", settings_companyState_data?.content[0]?.id || "")
            companyDetailsFormik.setFieldValue("shipperState", settings_companyState_data?.content[0]?.stateName || "")
        }
        if (settings_companyCountry_data && settings_companyCountry_data?.content?.length > 0 && activeItem === 'customerdetails') {
            companyDetailsFormik.setFieldValue("shipperCountryId", settings_companyCountry_data?.content[0]?.id || "")
            companyDetailsFormik.setFieldValue("shipperCountry", settings_companyCountry_data?.content[0]?.countryName || "")
            onShipperCountryChange(settings_companyCountry_data?.content[0]?.id || "")
        }
    }, [settings_companyState_data, settings_companyCountry_data, activeItem]);

    return (
        <>
            <Card>
                <CardBody>
                    <div className="row">
                        <div className="col-12 col-md-6 mb-4">
                            <div className="form-check form-switch" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="flexSwitchCheckDefault"
                                    disabled={companyDetailsFormik?.values?.isConsigneeCopyBillingAddress === true}
                                    checked={companyDetailsFormik?.values?.isShipperCopyBillingAddress || false}
                                    onClick={() => {
                                        const current = companyDetailsFormik?.values?.isShipperCopyBillingAddress || false;
                                        companyDetailsFormik.setFieldValue('isShipperCopyBillingAddress', !current);
                                        isCopyShipperSameAsBilling(!current);
                                    }}
                                />
                                <label
                                    className="form-check-label mt-2"
                                    htmlFor="flexSwitchCheckDefault"
                                    style={{ marginBottom: 0 }}>
                                    Same As Billing Address
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-6 mb-4">
                            <label className="form-label">First Name<span
                                className='required_star'>*</span></label>
                            <Input
                                type="text"
                                name="firstName"
                                value={companyDetailsFormik?.values?.firstName || ""}
                                onChange={async (e) => {
                                    await companyDetailsFormik.handleChange(e, true);
                                    companyDetailsFormik.setFieldTouched('firstName', true, true);
                                }}
                                className="form-control"
                                placeholder="Enter First Name..."
                            />
                            {companyDetailsFormik.touched.firstName &&
                                companyDetailsFormik.errors.firstName ? (
                                <FormFeedback type="invalid">
                                    {companyDetailsFormik.errors.firstName}
                                </FormFeedback>
                            ) : null}
                        </div>

                        <div className="col-12 col-md-6 mb-4">
                            <label className="form-label">Last Name</label>
                            <Input
                                type="text"
                                name="lastName"
                                value={companyDetailsFormik?.values?.lastName || ""}
                                onChange={companyDetailsFormik.handleChange}
                                onBlur={companyDetailsFormik.handleBlur}
                                className="form-control"
                                placeholder="Enter Last Name..."
                            />
                            {companyDetailsFormik.touched.lastName &&
                                companyDetailsFormik.errors.lastName ? (
                                <FormFeedback type="invalid">
                                    {companyDetailsFormik.errors.lastName}
                                </FormFeedback>
                            ) : null}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-6 mb-4">
                            <label className="form-label">Contact Number<span className='required_star'>*</span></label>
                            <Input
                                type="number"
                                name="contactNumber"
                                value={companyDetailsFormik?.values?.contactNumber || ""}
                                onChange={async (e) => {
                                    await companyDetailsFormik.handleChange(e, true);
                                    companyDetailsFormik.setFieldTouched('contactNumber', true, true);
                                }}
                                onBlur={companyDetailsFormik.handleBlur}
                                invalid={
                                    companyDetailsFormik.touched.contactNumber &&
                                        companyDetailsFormik.errors.contactNumber
                                        ? true
                                        : false
                                }
                                pattern="^\d{10}$"
                                placeholder="Please enter a valid 10-digit phone number"
                                maxLength="10"
                                minLength="10"
                                className="form-control"
                            />
                            <FormFeedback type="invalid">
                                    {companyDetailsFormik.errors.contactNumber}
                                </FormFeedback>
                        </div>

                        <div className="col-12 col-md-6 mb-4">
                            <label className="form-label">Email id<span className='required_star'>*</span></label>
                            <Input
                                type="text"
                                name="email"
                                value={companyDetailsFormik?.values?.email || ""}
                                onChange={companyDetailsFormik.handleChange}
                                onBlur={companyDetailsFormik.handleBlur}
                                className="form-control"
                                invalid={
                                    companyDetailsFormik.touched.email &&
                                        companyDetailsFormik.errors.email
                                        ? true
                                        : false
                                }
                                placeholder="Enter Email Address..."
                            />
                            {companyDetailsFormik.touched.email &&
                                companyDetailsFormik.errors.email ? (
                                <FormFeedback type="invalid">
                                    {companyDetailsFormik.errors.email}
                                </FormFeedback>
                            ) : null}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 mb-4">
                            <label className="form-label">Company Address</label>
                            <Input
                                type="text"
                                name="companyAddress"
                                value={companyDetailsFormik?.values?.companyAddress || ""}
                                onChange={companyDetailsFormik.handleChange}
                                onBlur={companyDetailsFormik.handleBlur}
                                className="form-control"
                                invalid={
                                    companyDetailsFormik.touched.companyAddress &&
                                        companyDetailsFormik.errors.companyAddress
                                        ? true
                                        : false
                                }
                                placeholder="Enter company address..."
                            />
                            {companyDetailsFormik.touched.companyAddress &&
                                companyDetailsFormik.errors.companyAddress ? (
                                <FormFeedback type="invalid">
                                    {companyDetailsFormik.errors.companyAddress}
                                </FormFeedback>
                            ) : null}
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="mb-3">
                                <label className="form-label">City<span className='required_star'>*</span></label>
                                <Input
                                    type="text"
                                    name="shipperCity"
                                    list="cityList"
                                    autoComplete="off"
                                    value={companyDetailsFormik?.values?.shipperCity || ""}
                                    onChange={async (e) => {
                                        await companyDetailsFormik.handleChange(e, true);
                                        companyDetailsFormik.setFieldTouched('shipperCity', true, true);
                                        companyDetailsFormik.setFieldValue('shipperState', '');
                                        companyDetailsFormik.setFieldValue('shipperCountry', '');
                                        companyDetailsFormik.setFieldValue('shipperZipcode', '');
                                        const cityData = settings_companyCity_data?.content?.find((city) => city.cityName === e.target.value);
                                        if (cityData) {
                                            companyDetailsFormik.setFieldValue('shipperCityId', cityData.id);
                                            dispatch(getCompanyStateData({ cityId: cityData.id }));
                                            dispatch(getCompanyCountryData({ cityId: cityData.id }));
                                            dispatch(getCompanyPincodeData({ cityId: cityData.id }));
                                        }
                                    }}
                                    className="form-control"
                                    placeholder="Type to search city..."
                                />
                                <FormFeedback>{companyDetailsFormik.errors.shipperCity}</FormFeedback>
                                <datalist id="cityList">
                                    {settings_companyCity_data &&
                                        settings_companyCity_data?.content?.map((item, i) => (
                                            <option key={i} value={item.cityName} />
                                        ))}
                                </datalist>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="mb-3">
                                <label className="form-label">State</label>
                                <Input
                                    type="text"
                                    name="shipperState"
                                    list="stateList"
                                    autoComplete="off"
                                    value={companyDetailsFormik?.values?.shipperState || ''}
                                    onChange={companyDetailsFormik.handleChange}
                                    className="form-control"
                                    placeholder="Type to search state..."
                                    readOnly={true}
                                />
                                <FormFeedback>{companyDetailsFormik.errors.shipperState}</FormFeedback>
                                <datalist id="stateList">
                                    {state_list &&
                                        state_list.map((item, i) => <option key={i} value={item} />)}
                                </datalist>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Country</label>
                                <Input
                                    type="text"
                                    name="shipperCountry"
                                    list="countryList"
                                    autoComplete="off"
                                    value={companyDetailsFormik?.values?.shipperCountry || ""}
                                    onChange={companyDetailsFormik.handleChange}
                                    className="form-control"
                                    placeholder="Type to search country..."
                                    readOnly={true}
                                />
                                <FormFeedback>{companyDetailsFormik.errors.shipperCountry}</FormFeedback>
                                <datalist id="countryList">
                                    {country_list &&
                                        country_list.map((item, i) => (
                                            <option key={i} value={item} />
                                        ))}
                                </datalist>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Zipcode</label>
                                <Input
                                    type="text"
                                    name="shipperZipcode"
                                    list="zipcodeList"
                                    autoComplete="off"
                                    value={companyDetailsFormik?.values?.shipperZipcode || ""}
                                    onChange={companyDetailsFormik.handleChange}
                                    className="form-control"
                                    placeholder="Type to search zipcode..."
                                />
                                <FormFeedback>{companyDetailsFormik.errors.shipperZipcode}</FormFeedback>
                                <datalist id="zipcodeList">
                                    {settings_companyPincode_data &&
                                        settings_companyPincode_data?.content?.map((item, i) => (
                                            <option key={i} value={item.pin} />
                                        ))}
                                </datalist>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <button className="btn btn-primary" onClick={(e) => {
                            e.preventDefault();
                            dispatch({ type: SETTINGS_INITIALIZE });
                            proceedToNext("consigneedetails");
                        }}>Continue</button>
                    </div>
                </CardBody>
            </Card>

        </>
    )
}

export default TenantsInformationForm;
